import accordionCollapse from './accordion-collapse.svg';
import accordionExpand from './accordion-expand.svg';
import bubble from './bubble.svg';
import checkboxChecked from './checkbox-checked.svg';
import checkboxCheckedDisabled from './checkbox-checked-disabled.svg';
import checkWhite from './check-white.svg';
import chevronRight from './chevron-right.svg';
import chevronRightWhite from './chevron-right_white.svg';
import grabIcon from './grab-icon.svg';
import iconLoadingSpinner from './icon-loading-spinner.png';
import minus from './minus.svg';
import pilotlaunchaiLogoGraphite from './pilotlaunch.ai_logo_graphite.svg';
import plusAccordion from './plus-accordion.svg';
import salesforceAppexchangeLogo from './logo-salesforce-appexchange.png';

export default {
  accordionCollapse,
  accordionExpand,
  bubble,
  checkboxChecked,
  checkboxCheckedDisabled,
  checkWhite,
  chevronRight,
  chevronRightWhite,
  grabIcon,
  iconLoadingSpinner,
  minus,
  pilotlaunchaiLogoGraphite,
  plusAccordion,
  salesforceAppexchangeLogo,
};
